import {ProfileState}from './state';

export enum ActionType {
    SetSelectedTab
  }


  export interface SetSelectedTab{
    type: ActionType.SetSelectedTab;
    payload: ProfileState;
  }
  

  export type ProfileActions = SetSelectedTab;